export default __webpack_public_path__ + "aaf1117d0f382c8fa14140093042db4b.png";